module.exports = __webpack_public_path__ + "img/slick_left_nano.96d6cd33.svg";